// https://medium.com/@Carmichaelize/react-importing-global-variables-from-the-window-object-b7db6665651d

export default window.Instructor_ID;
